<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->

<section id="tabs">
  <div class="container">
    <div class="col-xs-12">
      <div class="head_title">{{'L4 Manager KPI' | translate}}</div>
    </div>
    <br />
    <div class="row">
      <div class="col-xs-12 ">

        <nav>
          <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-smq-tab" data-toggle="tab" href="#nav-smq" role="tab"
              aria-controls="nav-smq" aria-selected="true">{{'SM-Q' | translate}}</a>
            <a class="nav-item nav-link" id="nav-smvs-tab" data-toggle="tab" href="#nav-smvs" role="tab" aria-controls="nav-smvs"
              aria-selected="false">{{'SM-VS' | translate}}</a>
            <a class="nav-item nav-link" id="nav-logistics-tab" data-toggle="tab" href="#nav-logistics" role="tab"
              aria-controls="nav-logistics" aria-selected="false">{{'LOGISTICS' | translate}}</a>
            <a class="nav-item nav-link" id="nav-operations-tab" data-toggle="tab" href="#nav-operations" role="tab"
              aria-controls="nav-operations" aria-selected="false">{{'OPERATIONS' | translate}}</a>
          </div>
        </nav>
        <div class="tab-content " id="nav-tabContent" style="    width: 1090px;">
          <div class="tab-pane fade show active" id="nav-smq" role="tabpanel" aria-labelledby="nav-smq-tab">
            <div style="display: block">
              <div class="help-block" align="center" id="custommessagesmq"></div>
              <div class="col-md-10" style="padding-left: 5px;">
                <canvas baseChart height="200" *ngIf="smqChartData" [datasets]="smqChartData" [labels]="xAxisCategoriessmq"
                  [options]="chartOpt" [legend]="barChartLegend" [colors]="lineChartColors" [chartType]="barChartType"></canvas>
              </div>
              <br />
            </div>
          </div>
          <div class="tab-pane fade" id="nav-smvs" role="tabpanel" aria-labelledby="nav-smvs-tab">
            <div style="display: block">
              <div class="help-block" align="center" id="custommessagesmvs"> </div>
              <div class="col-md-10" style="padding-left: 5px;">
                <canvas baseChart height="200" *ngIf="thirdChartData" [datasets]="thirdChartData" [labels]="xAxisCategoriessmvs"
                  [options]="chartOpt" [legend]="barChartLegend" [colors]="lineChartColors" [chartType]="barChartType"></canvas>
              </div>
              <br />
            </div>
          </div>
          <div class="tab-pane fade" id="nav-logistics" role="tabpanel" aria-labelledby="nav-logistics-tab">
            <div style="display: block">
              <div class="help-block" align="center" id="custommessagelogistics"> </div>
              <div class="col-md-10" style="padding-left: 5px;">
                <canvas baseChart height="200" *ngIf="logisticChartData" [datasets]="logisticChartData" [labels]="xAxisCategorieslogistic"
                  [options]="chartOpt" [legend]="barChartLegend" [colors]="lineChartColors" [chartType]="barChartType"></canvas>
              </div>
              <br />
            </div>
          </div>
          <div class="tab-pane fade" id="nav-operations" role="tabpanel" aria-labelledby="nav-operations-tab">
            <div style="display: block">
              <div class="help-block" align="center" id="custommessageOP"> </div>
              <div class="col-md-10" style="padding-left: 5px;">
                <canvas baseChart height="200" *ngIf="operationChartData" [datasets]="operationChartData" [labels]="xAxisCategoriesoperation"
                  [options]="chartOpt" [legend]="barChartLegend" [colors]="lineChartColors" [chartType]="barChartType"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>